<template>
  <div class="layout-builder-row-component" draggable="true" @dragstart="handleDragStart">Row Component</div>
</template>

<script setup>
const COMPONENT_TYPE = "LayoutBuilderRowContainer";

function handleDragStart(e) {
  e.dataTransfer.setData("application/x-component-type", COMPONENT_TYPE);
  e.dataTransfer.effectAllowed = "copy";
}
</script>

<style lang="scss" scoped>
.layout-builder-row-component {
  background-color: hsla(300, 70%, 70%, 0.1);
  width: 100%;
  height: 3rem;
  border-radius: var(--sp-comp-layout-builder-row-border-radius, 0.25rem);
  border: 1px solid hsla(340, 70%, 50%, 0.5);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: move;
  font-size: var(--sp-ref-font-size-small, 0.875rem);
  font-weight: var(--sp-ref-font-weight-medium, 500);
  color: hsla(340, 30%, 30%, 0.8);
}
</style>
